var SizeEnum;
(function (SizeEnum) {
    SizeEnum["xs"] = "xs";
    SizeEnum["s"] = "s";
    SizeEnum["m"] = "m";
    SizeEnum["l"] = "l";
    SizeEnum["xl"] = "xl";
})(SizeEnum || (SizeEnum = {}));

export { SizeEnum };
